import vmClient from 'app/services/vmClient';
import { Record } from 'immutable';
import { decodeOrThrow } from 'app/utils/ioTs';
import createErrorType from 'app/utils/createErrorType';
import * as t from 'io-ts';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { ALL_LANGUAGES, Language, LanguageMarshaller } from 'app/constants/enums/Language';

export class TranslationsMarshallerError extends createErrorType('TranslationsMarshallerError') {}

interface ILanguageMap { [key: string]: string | undefined }

const IOTranslations: t.Type<ILanguageMap> = t.partial(
  Object.fromEntries(ALL_LANGUAGES.map(curr => [curr.id, t.string])),
);

type Translations = Record<ILanguageMap>;
// Record returns a class type, which creates a runtime variable and identifier in the namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Translations = Record<ILanguageMap>({
  en: undefined,
  ja: undefined,
  es: undefined,
  id: undefined,
  it: undefined,
  ko: undefined,
  'pt-BR': undefined,
  ru: undefined,
  th: undefined,
  tlh: undefined,
  tr: undefined,
  vi: undefined,
  'zh-Hant': undefined,
  'zh-Hans': undefined,
});

const TranslationsMarshaller = {
  deserialize: (text: unknown): Translations => {
    const textData = decodeOrThrow(IOTranslations, text, (errors) => {
      throw new TranslationsMarshallerError(errors.join('\n'));
    });
    return new Translations(textData);
  },
  serialize: (text: Translations) => text,
};


export interface ILessonSentence extends IEntity {
  attributes: {
    lessonId: EntityStringId;
    cohortId: EntityStringId;
    language: Language;
    text: Translations;
  };
}

export type LessonSentence = Entity<ILessonSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonSentence: IEntityType<ILessonSentence> = vmClient.defineClass({
  typeName: 'LessonSentence',
  version: 1,
  attributes: {
    lessonId: {
      type: 'string',
      notNull: true,
    },
    cohortId: {
      type: 'string',
      notNull: true,
    },
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    text: {
      type: Translations,
      marshaller: TranslationsMarshaller,
      notNull: true,
    },
  },
});
